/**
 * Select2 calls
 * 
 */

jQuery(document).ready(function($) {
  if ($('select.select-2').length) {
    $('select.select-2').select2();
  }
});